import styled from "styled-components";

import { faAngleLeft, faAngleRight } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Flex, Justify, Wrap } from "@ntemarked/mittne-components/dist/Flex/Flex";

type WithActive = {
	active?: boolean;
};

const PaginationArrowButton = styled.button<WithActive>`
	background: none;
	border: none;
	color: #0089c4;
	width: 50px;
	height: 50px;
	padding: 0;
	border-radius: 50%;
	&:hover,
	&:focus,
	&:active {
		background: none;
		border: none;
		color: #004d6f;
	}
`;

const PaginationButton = styled.button<WithActive>`
	width: 50px;
	height: 50px;
	border: none;
	border-radius: 50%;
	padding: 0;
	line-height: 1;
`;

interface PaginationProps {
	total: number;
	perPage: number;
	currentPage: number;
	onChange: (newPage: number) => void;
	maxNumberToShow?: number;
	padding?: number;
}

function generateNumberRange(from: number, to: number) {
	const length = to - from;

	return Array.from(Array(length)).map((value, i) => i + from);
}

export default function Pagination(props: PaginationProps) {
	const pages = Math.max(Math.floor(props.total / props.perPage), 1);
	const maxNumberToShow = props.maxNumberToShow ?? 8;
	const padding = props.padding ?? 3;

	let fromTo: [number, number] = [0, pages];

	if (pages > maxNumberToShow) {
		fromTo = [Math.max(0, props.currentPage - padding), Math.min(props.currentPage + padding, pages)];
	}

	return (
		<Flex gap="10px" wrap={Wrap.wrap} justifyContent={Justify.center}>
			<PaginationArrowButton
				disabled={props.currentPage <= 0}
				onClick={() => {
					props.onChange(props.currentPage - 1);
				}}
			>
				<FontAwesomeIcon icon={faAngleLeft} />
			</PaginationArrowButton>
			{generateNumberRange(...fromTo).map((i) => (
				<PaginationButton disabled={props.currentPage === i} active={props.currentPage === i} key={i} type="button" onClick={() => props.onChange(i)}>
					{i + 1}
				</PaginationButton>
			))}
			<PaginationArrowButton
				disabled={props.currentPage + 1 >= pages}
				onClick={() => {
					props.onChange(props.currentPage + 1);
				}}
			>
				<FontAwesomeIcon icon={faAngleRight} />
			</PaginationArrowButton>
		</Flex>
	);
}
